import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const EnvelopeIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('EnvelopeIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.75 4.823 8.604 7.896c-.38.19-.828.19-1.208 0L1.25 4.823M2.6 2.798h10.8c.746 0 1.35.604 1.35 1.35v8.1a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35v-8.1c0-.746.604-1.35 1.35-1.35Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
EnvelopeIcon.id = 'EnvelopeIcon';
EnvelopeIcon.displayName = 'EnvelopeIcon';
export default EnvelopeIcon;
